module.exports = __webpack_public_path__ + "img/banner.40666651.png";